import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import { isVue2, isVue3, reactive } from 'vue-demi';
// 返回 vue3 $attrs。如果事件在 emits 中定义了的话，监听事件不会出现在 $attrs 中。
export function useAttrs(vm) {
  if (isVue2) {
    var _$vnode, _$vnode2, _$vnode3, _$vnode4;
    const attrs = reactive(_Object$assign({}, vm.$attrs));
    for (const [key, value] of _Object$entries(vm.$listeners)) {
      const newKey = 'on' + key.replace(/^\S/, s => s.toUpperCase());
      attrs[newKey] = value;
    }
    // 设置 class/style
    const staticClass = (_$vnode = vm.$vnode) === null || _$vnode === void 0 || (_$vnode = _$vnode.data) === null || _$vnode === void 0 ? void 0 : _$vnode.staticClass;
    const dynamicClass = (_$vnode2 = vm.$vnode) === null || _$vnode2 === void 0 || (_$vnode2 = _$vnode2.data) === null || _$vnode2 === void 0 ? void 0 : _$vnode2.class;
    attrs.class = [...(Array.isArray(staticClass) ? staticClass : [staticClass]), ...(Array.isArray(dynamicClass) ? dynamicClass : [dynamicClass])].filter(item => item);
    attrs.style = _Object$assign({}, (_$vnode3 = vm.$vnode) === null || _$vnode3 === void 0 || (_$vnode3 = _$vnode3.data) === null || _$vnode3 === void 0 ? void 0 : _$vnode3.staticStyle, (_$vnode4 = vm.$vnode) === null || _$vnode4 === void 0 || (_$vnode4 = _$vnode4.data) === null || _$vnode4 === void 0 ? void 0 : _$vnode4.style);
    return attrs;
  }
  return vm.$attrs;
}

// 返回 vue2 $attrs
export function useAttrsV2(vm) {
  if (isVue3) {
    const keys = Object.keys(vm.$attrs).filter(key => {
      return !/^on[A-Z]/.test(key) && key !== 'class' && key !== 'style';
    });
    const attrs = reactive({});
    keys.forEach(key => {
      attrs[key] = vm.$attrs[key];
    });
    return attrs;
  }
  return vm.$attrs;
}
export function passAttrs(attrs) {
  if (isVue2) {
    return reactive({
      attrs
    });
  }
  return attrs;
}